'use strict'

# On iOS all images are named 'image.jpg', so we will rename each image, so it has
# a unique name within the transfer.
class IOSImageRenamer
  @isRequired = ->
    window.navigator?.platform? and
      /iP(hone|od|ad)/.test window.navigator.platform

  constructor: (transfer) ->
    @transfer = transfer

  getString: ->
    'iOS-image-renamer'

  preProcessFile: (fileInfo, folder) ->
    if fileInfo.name is 'image.jpg'
      # Determine the new name
      d = fileInfo.lastModifiedDate.toISOString()
      date = d.substring(0, 10).replace /-/g, ''
      time = d.substring(11, 19).replace /:/g, ''
      baseName = "IMG#{date}-#{time}"
      proposedName = "#{baseName}.jpg"

      # Check if the name is unique
      counter = 0
      while counter++ is 0 or !unique
        unique = true
        for key, file of @transfer.files
          if file.name is proposedName and file.folder is folder
            proposedName = "#{baseName}-#{counter}.jpg"
            unique = false
            break

      # We should have an original name now
      fileInfo.name = proposedName
    true

export default IOSImageRenamer
